import React, { useState, useEffect } from 'react'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import CreatePage from '../../../composents/CreatePage'

const title = 'Restrictions'
const headers = {
  icon: 'feather icon-plus',
  title: title,
  description: 'creation of new restriction',
  breadcrumbs: [
    {
      title: title,
      link: '/water_cards/restrictions',
    },
  ],
}

export default function CreateCardPermission() {
  const [loader, setLoader] = useState(false),
    [errors, setErrors] = useState({}),
    [type, setType] = useState({
      value: 'client',
      label: 'Restricted to a Client',
    }),
    types = [
      {
        value: 'client',
        label: 'Restricted to a Client',
      },
      {
        value: 'meter',
        label: 'Restricted to meter',
      },
      {
        value: 'zone',
        label: 'Restricted to a Zone',
      },
      {
        value: 'city',
        label: 'Restricted to a City',
      },
      {
        value: 'country',
        label: 'Restricted to a Country',
      },
    ],
    modes = [
      {
        value: 'Entire Group',
        label: 'Entire Group  ',
      },
      {
        value: 'List Only',
        label: 'List Only',
      },
      {
        value: 'Group Except',
        label: 'Group Except',
      },
    ],
    [customers, setCustomers] = useState([]),
    [customer, setCustomer] = useState(),
    [meters, setMeters] = useState([]),
    [zones, setZones] = useState([]),
    [cities, setCities] = useState([]),
    [countries, setCountries] = useState([]),
    [elements, setElements] = useState([]),
    [element, setElement] = useState([])

  function onGetElement(params) {
    if (params) {
      let a = []
      params.forEach((el) => {
        a.push(el.value)
      })

      setElement(a)
    }
  }

  async function onGet() {
    let cli = await resources.customer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (cli.status === 200) {
      let a = []
      cli.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.name,
        })
      })
      setElements(a)
      setCustomers(a)
    }

    let met = await resources.meter
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (met.status === 200) {
      let a = []
      met.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.code,
          client: el?.client?.id,
        })
      })
      setMeters(a)
    }

    let zo = await resources.zone
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (zo.status === 200) {
      let a = []
      zo.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.zone + ' | ' + el.location,
          client: el.client.id,
        })
      })
      setZones(a)
    }

    let cit = await resources.city
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (cit.status === 200) {
      let a = []
      cit.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.name,
        })
      })
      setCities(a)
    }

    let cou = await resources.country
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (cou.status === 200) {
      let a = []
      cou.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.name,
        })
      })
      setCountries(a)
    }
  }

  useEffect(() => {
    switch (type.value) {
      case 'client':
        setElements(customers)
        break
      case 'meter':
        setElements(meters)
        break
      case 'zone':
        setElements(zones)
        break
      case 'city':
        setElements(cities)
        break
      case 'country':
        setElements(countries)
        break
      default:
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type])

  useEffect(() => {
    onGet()
  }, [])
  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = {}
    formData.forEach((value, key) => (object[key] = value))
    if (type) object.type = type.value
    if (element) object.restrictions = element
    if (customer) object.client = customer.value
    setLoader(true)
    setErrors({})

    let res = await resources.cardPermission
      .create(object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/hydrowallet/restrictions')
    } else if (res.status === 422) {
      setErrors(
        res.data.errors.reduce((acc, error) => {
          return { ...acc, [error.field]: error.message }
        }, {})
      )
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  const filterAll = () => {
    let all_cities = []
    if (customer) {
      if (type.value !== 'city' && type.value !== 'country' && type.value !== 'client') {
        all_cities = elements.filter((e) => e.client === customer.value)
      } else {
        all_cities = elements
      }
    }
    return all_cities
  }

  return (
    <CreatePage show_error={errors['not_autorized']} headers={headers}>
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>
              <div className="card-body">
                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Client <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    onChange={setCustomer}
                    options={customers}
                    required
                    isSearchable
                    isClearable
                  />
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Type of restriction <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    onChange={(e) => setType(e)}
                    options={types}
                    value={type}
                    isSearchable
                    isClearable={false}
                    className={errors['type'] ? ' is-invalid' : ''}
                  />
                  {errors['type'] && <div className="invalid-feedback">{errors['type']}</div>}
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    {type.value} <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    onChange={onGetElement}
                    isMulti
                    options={filterAll()}
                    className={errors['restrictions'] ? ' is-invalid' : ''}
                  />

                  {errors['restrictions'] && (
                    <div className="invalid-feedback">{errors['restrictions']}</div>
                  )}
                </div>

                <Field name="title" className="mb-3" error={errors['title']} required>
                  Title
                </Field>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Mode <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    name="mode"
                    options={modes}
                    isSearchable
                    isClearable={false}
                    className={errors['mode'] ? ' is-invalid' : ''}
                  />
                  {errors['mode'] && <div className="invalid-feedback">{errors['mode']}</div>}
                </div>

                <Field
                  name="description"
                  type="textarea"
                  className="mb-3"
                  error={errors['description']}
                >
                  Note
                </Field>

                <div className="row ">
                  <div className="col-lg-12">
                    <div className="d-grid gap-2">
                      <Btn class="btn waves-effect waves-light btn-primary" onLoad={loader}>
                        <i className="feather icon-save"></i> Submit
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </CreatePage>
  )
}
